import {useIsFeatureActive} from '@aboutyou/feature-flags';

export const useIsCouponWalletActive = () => {
  const isCouponWalletActive = useIsFeatureActive(
    'enable_coupon_wallet',
  ).isActive;
  const areCouponsActive = useIsFeatureActive('coupons').isActive;

  return isCouponWalletActive && areCouponsActive;
};
